var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alpine-layout d-flex",class:{'is-fullscreen' : _vm.isFullScreen}},[(_vm.oidcIsAuthenticated)?_c('AlpineNavBar'):_vm._e(),_c('main',{staticClass:"alpine-layout--main flex-grow-1 overflow-y-auto",attrs:{"id":_vm.alpineDefaultLayoutMainId}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }